import React from "react";
import { FormattedMessage } from "react-intl";
import { useCreateCheckoutSession } from "~/api/billing/billing";
import { UserRole } from "~/api/model";
import { useGetOrganization } from "~/api/organizations/organizations";
import { CalendlyWidget } from "~/components/3rd-party/CalendlyWidget";
import { DisplayFor } from "~/components/permissions/DisplayFor";
import { Button } from "~/components/ui/button";
import { CALENDLY_URL } from "~/constants/index";
import { useOrganizationParams } from "~/helpers";

export const PaymentRequiredBanner: React.FC = () => {
  const { mutate: createCheckoutSession } = useCreateCheckoutSession();
  const { organizationId } = useOrganizationParams();
  const { data: organizationInfo } = useGetOrganization(
    organizationId as string
  );

  const freeTrialLimit = organizationInfo?.freeTrialLimit || 1000;

  const handlePayment = () => {
    createCheckoutSession(
      { organizationId: organizationId as string },
      {
        onSuccess: (data) => {
          if (data.checkoutUrl) {
            window.open(data.checkoutUrl, "_blank");
          }
        },
      }
    );
  };

  const handleBookDemo = () => {
    const calendly = (window as any).Calendly;
    if (calendly?.initPopupWidget) {
      calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="bg-yellow-100 border border-yellow-300 text-yellow-700 pl-6 pr-4 py-4 rounded-md flex justify-between items-center"
      role="alert"
    >
      <CalendlyWidget />
      <div className="text-foreground flex flex-col gap-1">
        <p className="font-semibold">
          <FormattedMessage
            id="payment.trialIsOver"
            defaultMessage="Your Trial Period is Over"
          />
        </p>
        <p className="text-sm">
          <FormattedMessage
            id="payment.trialIsOver.hint"
            defaultMessage="Additional documents exceed your free trial of {limit} free pages. To continue using the service, please add your payment method."
            values={{ limit: freeTrialLimit.toLocaleString() }}
          />
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" onClick={handleBookDemo}>
          <FormattedMessage id="payment.bookDemo" defaultMessage="Book Demo" />
        </Button>
        <DisplayFor roles={[UserRole.OWNER, UserRole.SUPERADMIN]}>
          <Button onClick={handlePayment}>
            <FormattedMessage
              id="payment.update"
              defaultMessage="Update Payment"
            />
          </Button>
        </DisplayFor>
      </div>
    </div>
  );
};
